<template>
  <div>
    <div class="pb-3">
      <router-link
        :to="{ name: 'activist_taken_task_list', params: { task_id: $route.params.task_id } }"
        >Назад к списку</router-link
      >
    </div>
    <TakenTaskDetail v-if="task.id" :taken-task="task"></TakenTaskDetail>
  </div>
</template>

<script>
import TakenTaskDetail from '@/components/activist/TakenTaskDetail'
import { getTakenTaskDetailResponse } from '@/api/activist/task'

export default {
  name: 'TakenTaskListDetail',
  components: { TakenTaskDetail },
  data() {
    return {
      task: { id: '', task: { name: '' } },
    }
  },
  mounted() {
    this.getTakenTask()
  },
  methods: {
    getTakenTask() {
      getTakenTaskDetailResponse(this.axios, this.$route.params.taken_task_id)
        .then((resp) => {
          this.task = resp.data
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
  },
}
</script>
